import { render, staticRenderFns } from "./GameRecordEditComponent.vue?vue&type=template&id=1e61031e&scoped=true"
import script from "./GameRecordEditComponent.vue?vue&type=script&lang=js"
export * from "./GameRecordEditComponent.vue?vue&type=script&lang=js"
import style0 from "./GameRecordEditComponent.vue?vue&type=style&index=0&id=1e61031e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61031e",
  null
  
)

export default component.exports